import React from "react";
import { PaymentType } from "univapay-node";

import FormCodeInput from "../common/FormCodeInput";

export const Content = (props) => <FormCodeInput {...props} paymentType={PaymentType.CARD} />;

export default Content;
